if (!customElements.get("ajax-form")) {
  // TODO ensure this fetch is working in prod
  class AJAXForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.errorMessageContainer = this.querySelector(
        ".error-message_container"
      );
      this.submitButton = this.querySelector("button");

      if (this.form) {
        this.form.addEventListener("submit", this.ajaxSubmit.bind(this));
      }
    }
    ajaxSubmit(event) {
      event.preventDefault();
      const errorMessage = this.form.dataset.errorMessage;
      const successMessage = this.form.dataset.successMessage;
      const successHeading = this.form.dataset.successHeading;

      this.errorMessageContainer.innerText = "";
      this.updateLoadingState();
      fetch(this.form.action, {
        method: "POST",
        body: new FormData(this.form),
      })
        .then((response) => {
          if (response.ok) {
            this.updateFormSuccess(successMessage, successHeading);
          } else {
            this.updateFormError(errorMessage);
          }
        })
        .catch((e) => {
          this.updateFormError(errorMessage);
        });
    }
    updateFormSuccess(message, heading) {
      
//       this.form.classList.add("form-success");

//       const subheadingDiv = document.createElement("div");
//       subheadingDiv.classList.add("form-success-sub");
//       subheadingDiv.innerText = 'Success!';
      
//       this.form.innerHTML = "";
      
//       this.form.appendChild(subheadingDiv);
      
      $('.discount_popup').fadeIn(200);
      $('.offer_popup').fadeOut(200);
      $('.spintowin_summon').remove();
      localStorage.setItem('spintowinCompleted', 'spintowinCompleted');

    }
    updateFormError(message) {
      this.errorMessageContainer.innerText = message;
      this.updateLoadingState();
    }
    updateLoadingState() {
      if (this.submitButton.hasAttribute("disabled")) {
        this.submitButton.removeAttribute("disabled");
      } else {
        this.submitButton.setAttribute("disabled", true);
      }
    }
  }
  customElements.define("ajax-form", AJAXForm);
}
